/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Alert from "./Alert";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Patient from "./Patient";
import Card from "./Card";
import LoadingAlert from "./LoadingAlert";
import { qreq } from "../shared/qrequest";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import FormInput from "./FormInput";
import Globals from "../shared/Globals";
import { toast } from 'react-toastify';
import Insurance from "./Insurance"
import DocumentList from "./DocumentList";
import CommentList from "./CommentList";
import Auth from "../shared/Auth";
import ConfirmDialog from "./ConfirmDialog";
import { SidebarGlobal } from "./_SidebarGlobal";
import MessageDialog from "./MessageDialog";
import ConservativeCareLog from "./ConservativeCareLog";
import Icon from "./Icon";
import Person from "./Person";
import OrderProducts from "./OrderProducts";
import SendIVRModal from "./SendIVRModal";
import { Pop } from "./PopModal";
import MedicalRelease from "./MedicalRelease";
import { PatientLifecycleGlobal } from "./PatientLifecycle";
import AccountSelect from "./AccountSelect";
import { ChatBubbleGlobal } from "./chat/ChatBubble";
import UploadImage from "./UploadImage";
import SendDocumentsModal from "./SendDocumentsModal";
import EncounterList from "./EncounterList";
import RequestFormList from "./requestform/RequestFormList";
import DiagCodeSelect from "./DiagCodeSelect";
import OrderWounds from "./order/OrderWounds";
import OrderSummary from "./OrderSummary";
import AppActions from "./AppActions";
import Eligibility from "./Eligibility";
import ProductList from "./ProductList";
import ProductList2 from "./ProductList2";

class OrderView extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            id: 0,
            item: null,
            extra: {
                selectedWoundOther: false,
                woundTypesOther: ''
            },
            selectedWoundOther: false,
            tpl: null,
            loaded: false,
            notes: {},
            defaultTab: props.edit ? 'patient' : 'summary',
            tab: props.params.tab ? 'patient' : 'summary',
            reportList: [],
            edit: props.edit ?? false,
            accountList: [],
            providerList: [],
            productList: [],
            practiceList: [],
            editValues: {
                panels: []
            },
            woundTypes: [
                'Diabetic Foot Ulcer',
                'Venous Leg Ulcer',
                'Pressure Ulcer',
                'Traumatic Burns',
                'Radiation Burns',
                'Dehisced Surgical Wound',
                'Necrotizing Fasciitis'
            ],
            selectedWoundTypes: {},
            cptCodes: [
                '15271',
                '15272',
                '15273',
                '15274',
                '15275',
                '15276',
                '15277',
                '15278'
            ],
            selectedCPTCodes: {},
            examinationWound: {
                woundPosList: [],
                woundPosFeetList: []
            },
            units: [
                { id: 'cm', name: 'cm' },
                { id: 'in', name: 'in' }
            ],
            userList: [],
            assigned: []
        };
        if (this.props.params) {
            if (this.props.params.id)
                this.state.id = Number(this.props.params.id);
            if (this.props.params.tab)
                this.state.tab = this.props.params.tab;
        }
        this.load = this.load.bind(this);
        this.loadTables = this.loadTables.bind(this);
        this.pullTreatmentList = this.pullTreatmentList.bind(this);
        this.save = this.save.bind(this);
        this.publish = this.publish.bind(this);
        this.toggleEdit = this.toggleEdit.bind(this);
        this.setAutoSaveEnabled = this.setAutoSaveEnabled.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onAccountChange = this.onAccountChange.bind(this);
        this.onPatientSelect = this.onPatientSelect.bind(this);
        this.setIVRSent = this.setIVRSent.bind(this);
        this.setStatus = this.setStatus.bind(this);
        this.initSelectedWoundTypes = this.initSelectedWoundTypes.bind(this);
        this.initSelectedCPTCodes = this.initSelectedCPTCodes.bind(this);
        this.onSelectedWoundUnitsChange = this.onSelectedWoundUnitsChange.bind(this);
        this.setConservativeCare = this.setConservativeCare.bind(this);
        this.assign = this.assign.bind(this);
        this.requestSign = this.requestSign.bind(this);
        this.pullProducts = this.pullProducts.bind(this);
    }

    initSelectedWoundTypes() {
        var obj = {};
        var obj2 = {};
        var obj3 = {};
        var obj4 = {};
        var obj5 = {};
        var obj6 = {};
        var obj7 = {};
        this.state.woundTypes.forEach(i => {
            obj[i] = false;
            obj2[i] = 0;
            obj3[i] = 0;
            obj4[i] = 0;
            obj5[i] = 'cm';
            obj6[i] = 'cm';
            obj7[i] = 0;
        });
        this.setState({ selectedWoundTypes: obj, selectedWoundSizes: obj2, selectedWoundWidths: obj3, selectedWoundLengths: obj4, selectedWoundDepths: obj7, selectedWoundUnits: obj5, previousSelectedWoundUnits: obj6 });
    }

    onSelectedWoundUnitsChange(k, v) {
        this.onChange();
        /*
        var prev = this.state.previousSelectedWoundUnits[k];
        console.log(k, v, prev);
        var w = Number(this.state.selectedWoundWidths[k] ?? 0);
        var l = Number(this.state.selectedWoundLengths[k] ?? 0);
        console.log(w, l);
        if (v === 'cm' && prev === 'in') {
            w /= 2.54;
            l /= 2.54;
        }
        else if (v === 'in' && prev === 'cm') {
            w *= 2.54;
            l *= 2.54;
        }
        console.log(w, l);
        this.state.selectedWoundWidths[k] = w;
        this.state.selectedWoundLengths[k] = l;
        this.state.selectedWoundUnits[k] = v;
        this.state.previousSelectedWoundUnits[k] = v;
        this.setState({ woundTypes: this.state.woundTypes, selectedWoundUnits: this.state.selectedWoundUnits, previousSelectedWoundUnits: this.state.previousSelectedWoundUnits, selectedWoundWidths: this.state.selectedWoundWidths, selectedWoundLengths: this.state.selectedWoundLengths });
        */
    }

    initSelectedCPTCodes() {
        var obj = {};
        this.state.cptCodes.forEach(i => {
            obj[i] = false;
        });
        this.setState({ selectedCPTCodes: obj });
    }

    // Loaders

    load() {
        this.initSelectedWoundTypes();
        this.initSelectedCPTCodes();
        this.pullProducts();
        qreq.get('/api/order/get/' + this.state.id, (j) => {
            if (j.errorCode) {
                if (j.errorCode === 9)
                    this.props.navigate('/lead/edit/' + this.state.id);
                else
                    this.alert(j.errorMessage);
            }
            else {
                if (!j.item.patient)
                    j.item.patient = { id: 0, addressID: 0 };
                if (!j.item.patient.address)
                    j.item.patient.address = { id: 0 };

                if (j.item.examinationJsonData)
                    j.item.examination = JSON.parse(j.item.examinationJsonData);

                j.item.patient._assignedTo = [];
                if (j.item.patient.assignedTo) {
                    j.item.patient.assignedTo.forEach(i => {
                        j.item.patient._assignedTo.push(i.id);
                    });
                }

                this.setState({ item: j.item, originalItem: JSON.stringify(j.item), loaded: true });

                try {
                    var examinationWound = JSON.parse(j.item.examinationWoundJsonData);
                    if (!examinationWound.woundPosList)
                        examinationWound.woundPosList = [];
                    if (!examinationWound.woundPosFeetList)
                        examinationWound.woundPosFeetList = [];
                    this.setState({ examinationWound: examinationWound });
                }
                catch { }

                if (this.state.edit) {
                    this.loadTables();
                    this.setAutoSaveEnabled(true);
                }

                j.item.woundTypes.forEach(i => {
                    if (this.state.selectedWoundTypes[i.name] !== true && this.state.selectedWoundTypes[i.name] !== false)
                        this.state.woundTypes.push(i.name);
                    this.state.selectedWoundTypes[i.name] = true;
                    this.state.selectedWoundSizes[i.name] = i.woundSize;
                    this.state.selectedWoundWidths[i.name] = i.woundWidth;
                    this.state.selectedWoundLengths[i.name] = i.woundLength;
                    this.state.selectedWoundDepths[i.name] = i.woundDepth;
                    this.state.selectedWoundUnits[i.name] = 'cm';
                    this.state.previousSelectedWoundUnits[i.name] = 'cm';
                });

                j.item.cptCodes.forEach(i => {
                    this.state.selectedCPTCodes[i.code] = true;
                });

                if (this.qs('converted') === 'true') {
                    Pop.show(<>{this.T('subject')} <L>record</L> <strong>#{j.item.oid}</strong> <L>created.</L><br /><L>Don't forget to save the converted</L> <span className="text-lowercase">{this.T('subject')}</span> <L>record to complete submission.</L></>, <L>Draft Created</L>);
                }

            }
        });
    }

    loadTables() {
        qreq.get('/api/account/list', j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.list)
                this.setState({ accountList: j.list });
        });

        qreq.post('/api/provider/list', {}, j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else if (j.list)
                this.setState({ providerList: j.list });
        });

        this.fillList('/api/practice/list', 'practiceList', true);
    }

    pullTreatmentList(obj) {
        if (!obj || !obj.id)
            this.setState({ treatmentList: [] });
        else {
            qreq.post('/api/patient/treatment/list', { parentObjectID: obj.id }, j => {
                if (j.list)
                    this.setState({ treatmentList: j.list });
                else if (j.errorCode !== 0)
                    this.alert(j.errorMessage);
            });
        }

    }

    pullProducts() {
        qreq.post('/api/product/list', {}, j => {
            if (j.list) {
                var products = [];
                var sizes = [];
                j.list.forEach(i => {
                    var product = products.find(k => k.id === i.qCode);
                    if (!product)
                        products.push({ id: i.qCode, name: i.name });
                    var size = sizes.find(k => k.id === i.name + '-' + i.productSize);
                    if (!size) {
                        sizes.push({ id: i.qCode, name: i.productSize, productName: i.name, productID: i.id });
                    }
                });
                this.setState({ productList: products });
            }
        });
    }

    // Overrides

    componentDidUpdate(prevProps) {
        if (prevProps.params !== this.props.params) {
            if (this.props.params) {
                if (prevProps.params.tab !== this.props.params.tab)
                    this.setState({ tab: this.props.params.tab });
            }
        }
        if (prevProps.edit !== this.props.edit) {
            this.setState({ edit: this.props.edit });
        }

        if (this.state.item && !this.state.item.published && !this.state.edit) {
            this.toggleEdit();
        }
    }

    async componentDidMount() {
        this.load();

        qreq.get('/api/user/list?roleName=medical&showDisabled=false', j => {
            if (j.list)
                this.setState({ userList: j.list });
        });

        ChatBubbleGlobal.setOrder(this.state.id);

        await this.getSettings();


    }

    componentWillUnmount() {
        this.setAutoSaveEnabled(false);
        SidebarGlobal.clearSubNav();

        ChatBubbleGlobal.setOrder(null);
    }

    // Actions

    toggleEdit() {
        var tab;
        if (this.state.edit) {
            tab = this.state.tab === 'account' ? 'summary' : this.state.tab;
            this.setAutoSaveEnabled(false);
            this.setState({ edit: false, item: JSON.parse(this.state.originalItem) });
            this.props.navigate('/order/view/' + this.state.item.id + '/' + tab, { replace: true });
        }
        else {
            tab = this.state.tab === 'summary' || this.state.tab === 'visits' ? 'patient' : this.state.tab;
            this.loadTables();
            this.pullTreatmentList();
            this.setState({ edit: true, tab: tab });
            this.setAutoSaveEnabled(true);
            this.props.navigate('/order/edit/' + this.state.item.id + '/' + tab, { replace: true });
        }
    }

    setAutoSaveEnabled(bon) {
        if (bon) {
            if (!this.autoSaveInterval) {
                this.autoSaveInterval = setInterval(() => {
                    if (!this.state.item.published && this.bUpdate) {
                        this.bUpdate = false;
                        this.save();
                    }
                }, 5000);
            }
        }
        else {
            clearInterval(this.autoSaveInterval);
            this.autoSaveInterval = null;
        }
        this.setState({ autoSaveEnabled: bon });
    }

    // Editor

    save(e, publish) {
        if (e)
            e.preventDefault();

        if (publish) {
            if (!this.validate()) {
                return;
            }
        }
        if (this.state.item.accountID)
            this.state.item.accountID = Number(this.state.item.accountID);
        if (this.state.item.patient.birthDate) {
            try {
                var d = new Date(this.state.item.patient.birthDate);
                this.state.item.patient.birthDate = Globals.toMDYDateString(d);
                this.state.item.patient.hasBirthDate = true;
            }
            catch { }
        }

        var originalWoundTypes = [...this.state.item.woundTypes];
        this.state.item.woundTypes = [];
        for (var k in this.state.selectedWoundTypes) {
            if (this.state.selectedWoundTypes[k]) {
                var w = Number(this.state.selectedWoundWidths[k] ?? 0);
                var l = Number(this.state.selectedWoundLengths[k] ?? 0);
                var wd = Number(this.state.selectedWoundDepths[k] ?? 0);
                if (this.state.selectedWoundUnits[k] === 'in') {
                    w = w * 2.54;
                    l = l * 2.54;
                }
                this.state.item.woundTypes.push({ name: k, woundSize: String(this.state.selectedWoundSizes[k] ?? ''), woundWidth: w, woundLength: l, woundDepth: wd });
            }
            else {
                // eslint-disable-next-line no-loop-func
                originalWoundTypes.forEach(i => {
                    if (i.name === k) {
                        i.toRemove = true;
                        this.state.item.woundTypes.push(i);
                    }
                });
            }
        }

        if (this.state.extra.woundTypesOther && this.state.extra.woundTypesOther.trim()) {
            var p = this.state.extra.woundTypesOther.split(',');
            p.forEach(i => {
                this.state.item.woundTypes.push({ name: i.trim(), woundSize: '' });
            });
        }

        var originalCPTCodes = [...this.state.item.cptCodes];
        this.state.item.cptCodes = [];
        for (var kk in this.state.selectedCPTCodes) {
            if (this.state.selectedCPTCodes[kk])
                this.state.item.cptCodes.push({ code: kk });
            else {
                // eslint-disable-next-line no-loop-func
                originalCPTCodes.forEach(i => {
                    if (i.code === kk) {
                        i.toRemove = true;
                        this.state.item.cptCodes.push(i);
                    }
                });
            }
        }

        this.state.item.examinationJsonData = JSON.stringify(this.state.item.examination);
        this.state.item.examinationWoundJsonData = JSON.stringify(this.state.examinationWound);
        if (publish)
            this.setState({ saving: true });

        this.state.item.salesRepUserID = this.state.item.salesRepUserID ? parseInt(this.state.item.salesRepUserID) : 0;
        qreq.post('/api/order/save?publish=' + (publish ? 'true' : 'false'), this.state.item, j => {
            if (j.errorCode)
                this.setState({ error: j.errorMessage });
            else if (j.item) {
                if (j.item.examinationJsonData)
                    j.item.examination = JSON.parse(j.item.examinationJsonData);
                if (publish) {
                    this.setState({ item: j.item, edit: false });
                    this.load();
                    var tab = this.state.tab;
                    if (tab === 'account' || tab === 'integrations') {
                        tab = 'summary';
                        this.setState({ tab: tab });
                    }
                    this.props.navigate('/order/view/' + j.item.id + '/' + tab);
                }
                else {
                    this.setState({ item: { ...this.state.item, id: j.item.id } });
                    //toast('Draft auto saved!');
                }
            }
            this.setState({ saving: false });
        }, () => {
            this.setState({ saving: false });
        });
    }

    validate() {
        var errs = [];
        if (!Globals.isEmptyOrWhitespace(this.state.item.patient.firstName))
            errs.push('First Name is blank.');
        if (!Globals.isEmptyOrWhitespace(this.state.item.patient.lastName))
            errs.push('Last Name is blank.');
        if (!Globals.isEmptyOrWhitespace(this.state.item.patient.birthDate))
            errs.push('Birth Date is blank.');
        if (!Globals.isEmptyOrWhitespace(this.state.item.patient.gender))
            errs.push('Gender not selected.');
        if (!Globals.isEmptyOrWhitespace(this.state.item.patient.race))
            errs.push('Race not selected.');
        if (!Globals.isEmptyOrWhitespace(this.state.item.patient.ethnicity))
            errs.push('Ethnicity not selected.');
        return errs;
    }

    publish(e) {
        if (e) e.preventDefault();
        this.save(null, true);
    }

    // Changes

    onChange(obj) {
        this.bUpdate = true;
        this.setState({ item: this.state.item });
    }

    onAccountChange(obj) {
        this.onChange(obj);
        if (!this.state.item.provider.id) {
            this.state.accountList.forEach(i => {
                if (i.id === obj)
                    this.state.item.provider.id = i.defaultProviderID;
            });
        }
        this.setState({ item: { ...this.state.item, account: { ...this.state.item.account, id: obj } } });
    }

    onPatientSelect(v) {
        this.state.item.patient = v;
        this.setState({ item: this.state.item });
        this.onChange(v);
        this.pullTreatmentList(v);
    }

    setIVRSent() {
        this.confirmFunc = () => {
            this.state.item.status = 'IVR Sent';
            qreq.post('/api/order/status/set', this.state.item, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else if (j.item) {
                    this.state.item.status = j.item.status;
                    this.setState({ item: this.state.item });
                }
            });
            this.confirmFunc = null;
        };
        this.setState({ confirmMessage: 'Are you sure you want to set this order to IVR Sent?' });
    }

    setStatus(status) {
        this.confirmFunc = () => {
            this.state.item.status = status;
            qreq.post('/api/order/status/set', this.state.item, j => {
                if (j.errorCode)
                    this.alert(j.errorMessage);
                else if (j.item) {
                    this.state.item.status = j.item.status;
                    this.state.item.readyToProcess = j.item.readyToProcess;
                    this.state.item.treatmentStarted = j.item.treatmentStarted;
                    this.state.item.treatmentStartedDate = j.item.treatmentStartedDate;
                    this.state.item.treatmentEnded = j.item.treatmentEnded;
                    this.state.item.treatmentEndedDate = j.item.treatmentEndedDate;
                    this.setState({ item: this.state.item });
                    this.load();
                }
            });
            this.confirmFunc = null;
        };
        this.setState({ confirmMessage: 'Are you sure you want to set this order status to \'' + status + '\'?' });
    }

    setConservativeCare(b) {
        this.setState({ conservativeCareSubmitting: true });
        qreq.post('/api/conservative-care/order/set?orderID=' + this.state.item.id + '&set=' + (b ? 'true' : 'false'), {}, j => {
            console.log(j);
            if (j.errorCode === 0) {
                toast.success('Conservative care ' + (b ? 'enabled' : 'disabled') + '!');
                this.setState({ item: { ...this.state.item, isConservativeCare: b } });
            }
            else
                toast.error(j.errorMessage);
            this.setState({ conservativeCareSubmitting: false });
        }, () => {
            toast.error('Unknown error ocurred. Please try again.');
            this.setState({ conservativeCareSubmitting: false });
        })
    }


    assign() {
        var patient = { ...this.state.item.patient };
        patient.assignedTo = [];
        patient._assignedTo.forEach(i => {
            patient.assignedTo.push({ id: i });
        })
        qreq.post('/api/patient/assign/users', patient, j => {
            if (j.errorCode)
                this.alert(j.errorMessage);
            else
                this.success('Assigned to saved!');
        }, this.unkownErrorCallback);
    }

    requestSign() {
        Pop.showConfirm('Are you sure you want to request a signature for this patient?', 'Request Signature', () => {
            this.setState({ requesting: true });
            qreq.post('/api/document/sign/request', { orderID: this.state.item.id }, j => {
                if (j.errorCode === 0) {
                    this.success('Signature request sent.');
                }
                else
                    this.alert(j.errorMessage);
                this.setState({ requesting: false });
            }, () => {
                this.unkownErrorCallback();
                this.setState({ requesting: false });
            });
        });
    }


    downloadDemographics = () => {
        window.open(Globals.serverUrl + '/api/order/demographic/report/pdf/' + this.state.item.id + '/' + this.state.item.oid + '.pdf');
    }

    rollbackToQueue = () => {
        Pop.showConfirm('Are you sure you want to rollback this record to queue?', 'Rollback Record', () => {
            this.setState({ rollback: true });
            qreq.post('/api/order/rollback', { id: this.state.item.id }, j => {
                if (j.errorCode === 0) {
                    this.props.navigate('/lead/edit/' + this.state.item.id);
                }
                else
                    this.alert(j.errorMessage);
                this.setState({ rollback: false });
            }, () => {
                this.unkownErrorCallback();
                this.setState({ rollback: false });
            });
        });
    }

    checkEligibility = async () => {
        try {
            const j = await qreq.postAsync('/api/insurance/eligibility', { ...this.state.item });
            if (j.errorCode === 0) {
                this.success('Initiated verification process...');
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
    }


    onSendDocs = (callback) => {
        if (callback) callback();
        this.rehash();
    }

    referringProviderChanged = (id) => {
        const provider = this.state.providerList.find(x => x.id === Number(id));
        if (!provider) return;
        const item = { ...this.state.item };
        item.referringProvider = { ...provider };
        this.setState({ item: item });
    }


    // Render

    render() {


        const scc_f = () => {
            var c = 0;
            for (var k in this.state.selectedCPTCodes) {
                if (this.state.selectedCPTCodes[k])
                    c++;
            }
            if (c === 0)
                return <Alert message="There are no CPT Codes selected." />;
            else
                return '';
        };

        if (!this.state.loaded)
            return <div className="container-fluid"><h1><L>Patient</L></h1><LoadingAlert /></div>;

        if (!this.state.item)
            return (<Alert message="Order not found." icon="ExclamationCirlce" type="danger" />)

        SidebarGlobal.setSubNav(<><div className="btn-group">
            {this.state.edit ?
                this.state.item.published ? <button type="button" className="btn btn-success" onClick={this.publish}><FontAwesomeIcon icon={fa.faSave} /> <span className="d-none d-md-inline"><L>Save</L></span></button> : <button type="button" className="btn btn-success" onClick={this.publish}><FontAwesomeIcon icon={fa.faSave} /> <span className="d-none d-md-inline"><L>Publish</L></span></button> : ''}
            {!Auth.hasRole('readonly') && (Auth.hasRole('account-manager') && this.state.item.published ? <button type="button" className={'btn ' + (this.state.edit ? 'btn-secondary' : 'btn-primary')} onClick={e => this.toggleEdit()}>{this.state.edit ? <><FontAwesomeIcon icon={fa.faTimes} /> <span className="d-none d-md-inline"><L>Cancel Edit</L></span></> : <><FontAwesomeIcon icon={fa.faPencil} /> <span className="d-none d-md-inline"><L>Edit Patient</L></span></>}</button> : '')}
        </div></>);

        const header = (<>
            <h1 className="fixed"><strong>{this.state.item?.patient?.lastName}, {this.state.item?.patient?.firstName}</strong> #{this.state.item?.oid} (<span className="d-inline d-md-none text-muted"><L>P</L></span><span className="d-none d-md-inline text-muted"><L>Patient</L></span>){this.state.item.published ? '' : <> <span className="badge bg-secondary"><L>Draft</L></span></>}</h1>
        </>);

        return (<div className="container-fluid">
            <div className="p-4"></div>
            <SendDocumentsModal item={this.state.item} show={this.state.showSendDocumentsModal} onHide={() => this.setState({ showSendDocumentsModal: false })} onSend={this.onSendDocs} />
            <SendIVRModal item={this.state.item} show={this.state.showSendIVR} onHide={() => { this.setState({ showSendIVR: false }); this.load(); }} onSend={this.onSendDocs} />
            {this.wrapModal(<OrderProducts orderID={this.state.item.id} />, 'Products', 'xl', this.state.showProductsModal, () => this.setState({ showProductsModal: false }))}
            {header}
            <div className="row mb-3 after-h1-fixed">
                <div className="col-md">
                </div>
                <div className="col-md text-md-end">
                    <div className="btn-group d-none">
                        {this.state.edit ?
                            this.state.item.published ? <button type="button" className="btn btn-success" onClick={this.publish}><FontAwesomeIcon icon={fa.faSave} /> <L>Save</L></button> : <button type="button" className="btn btn-success" onClick={this.publish}><FontAwesomeIcon icon={fa.faSave} /><L>Publish</L></button> : ''}
                        {this.state.item.published ? <button type="button" className={'btn ' + (this.state.edit ? 'btn-secondary' : 'btn-primary')} onClick={e => this.toggleEdit()}>{this.state.edit ? <><FontAwesomeIcon icon={fa.faTimes} /><L>Cancel Edit</L></> : <><FontAwesomeIcon icon={fa.faPencil} /><L>Edit Patient</L></>}</button> : ''}
                    </div>
                </div>
            </div>
            <ConfirmDialog show={this.state.confirmMessage} title="Confirm" message={this.state.confirmMessage} onConfirm={this.confirmFunc} onHide={() => this.setState({ confirmMessage: null })} />
            {this.state.saving ? <MessageDialog title="Saving" message="Please wait..." /> : ''}
            {this.state.error ? <MessageDialog title="Error">
                <p>{this.state.error}</p>
                <div className="d-grid gap-2 mt-2">
                    <button type="button" className="btn btn-secondary" onClick={() => this.setState({ error: null })}>Close</button>
                </div>
            </MessageDialog> : ''}
            {!this.state.edit ? <AppActions>
                {Auth.hasRole('manager') && <div className="text-end">
                    <DropdownButton title="Actions" size="lg" drop="up" className="has-icons">
                        {this.state.MODEL === 'WMS' && (this.state.MODELPROPS?.indexOf('WOUND') >= 0 || this.state.MODELPROPS?.indexOf('LYMPH') >= 0) && <Dropdown.Item onClick={() => PatientLifecycleGlobal.showSelect()}><Icon icon="faPencil" /> <L>Change Lifecycle Phase</L></Dropdown.Item>}
                        {this.state.MODEL === 'WMS' && this.state.MODELPROPS?.indexOf('WOUND') >= 0 && <Dropdown.Item href={Globals.serverUrl + '/api/document/render/ivr/' + this.state.item.id + '/v2'} target="_blank" rel="noreferrer"><Icon icon="faFilePdf" /> <L>Export IVR Report</L></Dropdown.Item>}
                        <Dropdown.Item onClick={this.downloadDemographics}><Icon icon="faFilePdf" /> <L>Export Demographics Report</L></Dropdown.Item>
                        {Auth.hasRole('admin') && <Dropdown.Item onClick={() => this.setState({ showSendDocumentsModal: true })}><Icon icon="faShare" /> <L>Share Documents</L></Dropdown.Item>}
                        {this.state.MODEL === 'WMS' && this.state.MODELPROPS?.indexOf('WOUND') >= 0 && this.state.item.status === 'IVR Sent' || this.state.item.status === 'IVR Result - Need Info' ? <><Dropdown.Item onClick={() => this.setStatus('IVR Result - OK')}><Icon icon="faCheck" /> <L>IVR Result - Approved</L></Dropdown.Item>
                            {this.state.item.status !== 'IVR Result - Need Info' ? <Dropdown.Item onClick={() => this.setStatus('IVR Result - Need Info')}><Icon icon="faQuestion" /> <L>IVR Result - Need Info</L></Dropdown.Item> : ''}
                            <Dropdown.Item onClick={() => this.setStatus('IVR Result - Declined')}><Icon icon="faTimes" /> <L>IVR Result - Declined</L></Dropdown.Item></> : ''}

                        {this.state.MODEL === 'WMS' && this.state.MODELPROPS?.indexOf('WOUND') >= 0 && <Dropdown.Item onClick={() => this.requestSign()}><Icon icon="faSignature" /> <L>Request IVR Signature</L></Dropdown.Item>}
                        {this.state.MODEL === 'WMS' && this.state.MODELPROPS?.indexOf('WOUND') >= 0 && <Dropdown.Item onClick={() => this.setState({ showSendIVR: true })}><Icon icon="faPaperPlane" /> {this.state.item.status === 'IVR Sent' ? 'Resend IVR' : 'Send IVR'}</Dropdown.Item>}
                        {this.state.MODEL === 'WMS' && this.state.MODELPROPS?.indexOf('WOUND') >= 0 && this.state.item.status === 'Profile Completed' ? <Dropdown.Item type="button" onClick={this.setIVRSent}><Icon icon="faCheck" /> <L>Set to IVR Sent</L></Dropdown.Item> : ''}

                        {this.state.MODEL === 'WMS' ? <Dropdown.Item type="button" onClick={this.checkEligibility}><Icon icon="faTimeline" /> <L>Check Eligibility</L></Dropdown.Item> : ''}

                        <Dropdown.Item onClick={() => this.props.navigate('/schedule/new/patient/' + this.state.item.patient.id)}><Icon icon="faCalendar" /> <L>Schedule Encounter</L></Dropdown.Item>
                        {this.state.MODEL === 'WMS' && (this.state.MODELPROPS?.indexOf('WOUND') >= 0 || this.state.MODELPROPS?.indexOf('LYMPH') >= 0) && this.state.item.readyToProcess && !this.state.item.treatmentEnded ? <>
                            <Dropdown.Item onClick={() => this.setStatus('Discharge')}><Icon icon="faCheck" /> Set Discharge (Finalize)</Dropdown.Item>
                            <Dropdown.Item onClick={() => this.setStatus('IVR Sent')}><Icon icon="faArrowLeft" /> <L>Set back to 'IVR Sent' status</L></Dropdown.Item>
                        </> : ''}
                        {this.state.item.treatmentEnded ?
                            <Dropdown.Item onClick={() => this.setStatus('Treatment In Progress')}><Icon icon="faArrowLeft" /> <L>Set back to In Progress</L></Dropdown.Item> :
                            <Dropdown.Item onClick={() => this.setStatus('Deceased')}><Icon icon="faSkullCrossbones" /> <L>Set Patient Deceased</L></Dropdown.Item>}
                        <Dropdown.Divider />
                        <Dropdown.Item disabled={this.state.conservativeCareSubmitting} onClick={() => this.setConservativeCare(!this.state.item.isConservativeCare)}><Icon icon="faBed" /> {this.state.item.isConservativeCare ? 'Disable Conservative Care' : 'Enable Conservative Care'}</Dropdown.Item>
                        <Dropdown.Divider />
                        {Auth.hasRole('admin') && <Dropdown.Item onClick={() => this.rollbackToQueue()}><Icon icon="faArrowLeft" /> <L>Rollback to Queue</L></Dropdown.Item>}
                        <Dropdown.Item onClick={() => this.props.navigate(`/lead/edit/${this.state.item?.id}`)}><Icon icon="faInfo" /> <L>View Queue Record</L></Dropdown.Item>

                    </DropdownButton>
                </div>}
            </AppActions> : <AppActions>
                <button type="button" className="btn btn-success btn-lg" onClick={this.publish}><Icon icon="faSave" /> <L>Save</L></button>
            </AppActions>}

            <Tabs
                activeKey={this.state.tab}
                defaultActiveKey={this.state.tab}
                onSelect={(k) => { this.setState({ tab: k }); this.props.navigate('/order/' + (this.state.edit ? 'edit' : 'view') + '/' + this.state.id + '/' + k, { replace: true }); }}
                id="c-order-tabs"
                className="app-tabs"
                animation="false">
                {this.state.edit ? '' :
                    <Tab eventKey="summary" title="Summary">
                        <OrderSummary
                            item={this.state.item}
                            userList={this.state.userList}
                            onChange={this.load}
                        />
                    </Tab>}
                {this.state.MODEL === 'WMS' && !this.state.edit && <Tab eventKey="visits" title="Encounters">
                    <Card title="Encounters">
                        <EncounterList orderID={this.state.item.id} />
                    </Card>
                </Tab>}
                {this.state.edit ?
                    <Tab eventKey="account" title="Account">
                        <Card>
                            <FormInput disabled={this.state.locked} model={this.state.item} name="productQCode" label="Product" type="select" options={this.state.productList} onChange={this.onChange} />
                            <FormInput model={this.state.item.provider} name="id" label="Provider" type="select" options={this.state.providerList} required={true} onChange={this.onChange} />
                            <FormInput model={this.state.item.referringProvider} name="id" label="Referring Provider" type="select" options={this.state.providerList} required={false} onChange={this.referringProviderChanged} />
                            <FormInput model={this.state.item.account} name="id" label="Holder Account" type="select" options={this.state.accountList} required={true} onChange={this.onAccountChange} />
                            <FormInput model={this.state.item} name="practiceID" label="Practice" type="select" options={this.state.practiceList} required={true} onChange={this.onChange} />
                            <label className="form-label"><L>Related Accounts</L></label>
                            <AccountSelect selectedAccounts={this.state.item.accounts} mainAccountID={parseInt(this.state.item.account?.id ?? 0)} onChange={list => this.setState({ item: { ...this.state.item, accounts: list } })} />
                            <div className="mt-3"></div>
                            <FormInput
                                disabled={this.state.locked}
                                model={this.state.item}
                                name="salesRepUserID"
                                label="Care Coordinator"
                                type="select"
                                options={this.state.userList.filter(a => a.isSalesRep)}
                                onChange={this.onChange}
                            />
                        </Card>
                    </Tab> : ''}
                <Tab eventKey="patient" title="Patient">
                    {!this.state.item.patient.id && !this.state.item.patient.isNew && this.state.edit ? <Card title="Select or create Patient" style={{ overflow: 'visible' }}>
                        <div className="row">
                            <div className="col-md">
                                <FormInput model={this.state.item.patient} name="id" label="Select an existing Patient" type="search" searchUrl="/api/patient/list" onChange={this.onPatientSelect} />
                            </div>
                            <div className="col-md">
                                <div className="form-label"><L>Is this a first time patient?</L></div>
                                <button type="button" className="btn btn-primary" onClick={() => { this.state.item.patient.isNew = true; this.setState({ item: this.state.item }); }}><FontAwesomeIcon icon={fa.faFileMedical} /><L>Create New Patient</L></button>
                            </div>
                        </div>
                    </Card>
                        :
                        <>
                            <div className="row">
                                <div className="col-sm-9">
                                    <Patient title="Patient Demographics" item={this.state.item.patient} requestAddress={true} addressTitle="Patient Address" readOnly={!this.state.edit} onChange={this.onChange} requestContact />
                                </div>
                                <div className="col-sm-3">
                                    <Card title="Profile Photo">
                                        {this.state.edit ? <UploadImage fileIdent={this.state.item.patient.photoIdent} onChange={img => { this.state.item.patient.photoIdent = img.fileIdent; this.setState({ item: { ...this.state.item, patient: { ...this.state.item.patient, photoIdent: img.fileIdent } } }); this.onChange(); }} className="text-center" /> : <img src={Globals.getStorageURL(this.state.item.patient.photoIdent, true)} alt="Patient" className="img-fluid" />}
                                    </Card>
                                </div>
                            </div>
                            <Card>
                                {this.state.edit ?
                                    <FormInput type="switch" model={this.state.item} name="usePatientAddressAsFacility" label="Use Patient Address as Facility in IVR" /> :
                                    <>Use Patient Address as Facility in submission of IVR (Patient is getting treated at home): <strong>{this.state.item.usePatientAddressAsFacility ? 'YES' : 'NO'}</strong></>}
                            </Card>
                        </>}
                </Tab>
                <Tab eventKey="referrer" title="Referrer">
                    <Person item={this.state.item.referrer} title="Contact" requireOnlyBasic requestContact readOnly={!this.state.edit} />
                </Tab>
                <Tab eventKey="insurance" title="Insurance">
                    {this.state.item.insurances.length === 0 ? <Card title="Insurances"><Alert message="There are no insurances in record." /></Card> : ''}
                    {this.state.item.insurances.map(obj => <div key={obj.id ?? obj.key}>{!obj.toRemove ? <Insurance item={obj} edit={this.state.edit} remove={i => { i.toRemove = true; this.onChange(); this.setState({ item: this.state.item }); }} onChange={this.onChange} /> : ''}</div>)}
                    {this.state.edit ? <div className="btn-group p-3">
                        <button type="button" className="btn btn-primary" onClick={() => this.addToList(this.state.item.insurances, {})} ><FontAwesomeIcon icon={fa.faPlus} /> Add {this.state.item.insurances.length === 0 ? 'First' : 'Another'} Insurance</button>
                    </div> : ''}
                    <Eligibility order={this.state.item} />
                </Tab>
                <Tab eventKey="products" title="Products">
                    <ProductList2 order={this.state.item} edit={this.state.edit} onSelectProduct={this.load} onRemoveProduct={this.load} />
                </Tab>
                {this.state.MODEL === 'WMS' && this.state.MODELPROPS?.indexOf('WOUND') >= 0 && <Tab eventKey="wounds" title="Wounds">
                    <OrderWounds item={this.state.item} />
                </Tab>}
                {this.state.MODEL === 'WMS' && this.state.MODELPROPS?.indexOf('WOUND') >= 0 && <Tab eventKey="diagnosis" title="Diag/CPT">
                    {this.state.edit ? <DiagCodeSelect item={this.state.item} onChange={this.onChange} />
                        : <Card title="Diagnosis Codes">
                            <ul className="list-group">
                                {this.state.item.diagCodes?.map((i, idx) => <li key={idx} className="list-group-item d-flex">
                                    <div style={{ minWidth: '100px' }}>{i.code}</div>
                                    <div>{i.description}</div>
                                </li>)}
                            </ul>
                        </Card>}
                    <Card title="CPT Codes">
                        {this.state.edit ? this.state.cptCodes.map(obj => <div key={obj}><FormInput type="switch" model={this.state.selectedCPTCodes} name={obj} label={obj} /></div>) :
                            this.state.cptCodes.map(obj => <div key={obj}>{this.state.selectedCPTCodes[obj] ? <strong>{obj}</strong> : ''}</div>)
                        }
                        {!this.state.edit ? scc_f() : ''}
                    </Card>
                </Tab>}
                {!Auth.hasRole('external') && <Tab eventKey="notes" title="Notes">
                    <CommentList isLead isSystem={false} orderId={this.state.item.id} noForm hash={this.state.hash} />
                    {this.state.item.notes && <Card title="Legacy Notes">
                        <div className="p-2 bg-white" dangerouslySetInnerHTML={{ __html: this.processComment(this.state.item.notes) }}></div>
                        <small className="text-muted"><L>These are notes that where created before the new notes system.</L></small>
                    </Card>}
                </Tab>}
                <Tab eventKey="documents" title="Documents">
                    {this.state.tab === 'documents' && <DocumentList list={this.state.item.documents} parentItem={this.state.item} edit />}
                    <MedicalRelease item={this.state.item} />
                    <RequestFormList item={this.state.item} />
                </Tab>
                {!this.state.edit && this.state.item.published && this.state.item.id && (this.state.item.isConservativeCare || this.state.item.hasConservativeCareLogs) ? <Tab eventKey="conservative-care" title="Conservative Care">
                    <ConservativeCareLog orderID={this.state.item.id} allowSubmitting={this.state.item.isConservativeCare} />
                </Tab> : ''}
                {this.state.edit ? <Tab eventKey="integrations" title="Integrations">
                    <Card title="Integrations">
                        <FormInput model={this.state.item} name="externalSync" label="Enable Integration" type="switch" onChange={this.onChange} />
                        {this.state.item.externalSync ? <>
                            <FormInput model={this.state.item} name="externalSource" label="External Source" type="select" onChange={this.onChange} options={[
                                { id: 'HEALTHFUSION', name: 'Health Fusion' }
                            ]} />
                            <FormInput model={this.state.item} name="externalID" label="External ID" type="text" onChange={this.onChange} />
                        </> : ''}
                    </Card>
                </Tab> : ''}
                {!this.state.edit && this.state.item.published && Auth.hasRole('admin') ? <Tab eventKey="assignedTo" title="Assigned">
                    <Card title="Assigned Practitioner">
                        <FormInput model={this.state.item.patient} type="multiselect" name="_assignedTo" label="Assignment" options={this.state.userList} loadValueOnce />
                        <div className="mb-2">
                            <button type="button" className="btn btn-primary" onClick={this.assign}><Icon icon="faSave" /> <L>Assign</L></button>
                        </div>
                    </Card>
                </Tab> : ''}
            </Tabs>
        </div>);
    }

}

export default withParamsAndNavigate(OrderView);